import { colorSurfacePrimary } from 'component/color';

// Opacities  (opacity is in hex)

export function parseHexColor(hexColor: string): { r: number; g: number; b: number } {
    return {
        r: parseInt(hexColor.slice(1, 3), 16),
        g: parseInt(hexColor.slice(3, 5), 16),
        b: parseInt(hexColor.slice(5, 7), 16),
    };
}

export function toHexColor(r: number, g: number, b: number): string {
    const toHex = (c: number) => Math.round(c).toString(16).padStart(2, '0').toUpperCase();
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
function colorBrightness(hexColor: string): number {
    const { r, g, b } = parseHexColor(hexColor);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}
function darkenColor(hexColor: string, percentage: number): string {
    const { r, g, b } = parseHexColor(hexColor);

    const rDark = r * (1 - percentage);
    const gDark = g * (1 - percentage);
    const bDark = b * (1 - percentage);

    return toHexColor(rDark, gDark, bDark);
}
function lightenColor(hexColor: string, percentage: number): string {
    const { r, g, b } = parseHexColor(hexColor);

    const rLight = r * (1 - percentage) + 255 * percentage;
    const gLight = g * (1 - percentage) + 255 * percentage;
    const bLight = b * (1 - percentage) + 255 * percentage;

    return toHexColor(rLight, gLight, bLight);
}

export function translucentHoverColor(): string {
    return colorBrightness(colorSurfacePrimary) <= 0.2 ? '#FFFFFF33' : '#00000033';
}

export function translucentPressColor(): string {
    return colorBrightness(colorSurfacePrimary) <= 0.2 ? '#FFFFFF66' : '#00000066';
}

export function toHoverColor(hexColor: string): string {
    if (colorBrightness(hexColor) <= 0.2) {
        return lightenColor(hexColor, 0.2);
    } else {
        return darkenColor(hexColor, 0.2);
    }
}

export function toPressColor(hexColor: string): string {
    if (colorBrightness(hexColor) <= 0.2) {
        return lightenColor(hexColor, 0.4);
    } else {
        return darkenColor(hexColor, 0.4);
    }
}
